import { render, staticRenderFns } from "./transitPort_Component.vue?vue&type=template&id=c1b889ee&scoped=true&"
import script from "./transitPort_Component.vue?vue&type=script&lang=js&"
export * from "./transitPort_Component.vue?vue&type=script&lang=js&"
import style0 from "./transitPort_Component.vue?vue&type=style&index=0&id=c1b889ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b889ee",
  null
  
)

export default component.exports